<template>
  <el-dialog title="详情" :visible.sync="dialogTableVisible" append-to-body>
    <div class="view pa24">
      <commonTable
          :tableData="tableData"
          :total="total"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:table>
          <el-table-column
              prop="className"
              align="center"
              label="产品"
          />
          <el-table-column
              prop="handle"
              align="center"
              label="标识"
              width="300"
          >
            <template slot-scope="scope">
              {{ scope.row.handle }}
              <span
                  :class="scope.row.type == 3?'name_status':'name_status1'">{{ scope.row.type == 3 ? '箱' : '盒' }}</span>
              <span class="copyTxt" @click="copy(scope.row.handle)"><img src="../../../assets/images/fz.png"/></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="warehouseName"
              align="center"
              label="仓库"
          />
          <el-table-column
              align="center"
              label="接收方"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.dealerCode ? scope.row.dealerCode : '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="nickName"
              align="center"
              label="出库人"
          />
          <el-table-column
              prop="createTime"
              align="center"
              label="出库时间"
          />
        </template>
      </commonTable>
    </div>
  </el-dialog>

</template>

<script>
import commonTable from "@/components/common/commonTable";
import {outLogDetail} from "@/api/crk";

export default {
  name: "outDetail",
  components: {
    commonTable
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      wareStatus: 2,
      serchParams: {
        dealerId: null
      },
      dialogTableVisible: false,
      batchId:''
    };
  },
  created() {
  },
  methods: {
    init(batchId){
      this.batchId = batchId
      this.getList()
      this.dialogTableVisible = true
    },
    copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success('复制成功');
      // 复制后移除输入框
      oInput.remove();
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    serchquery() {
      this.getList()
    },
    reset() {
      this.serchParams.dealerId = null
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        wareStatus: 2,
        batchId: this.batchId
      }
      Object.assign(params, this.serchParams)
      outLogDetail(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}
</style>

